/**
 * Testimonials Slider Block
 */

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

export function initTestimonialsSlider() {
    const testimonialsSliders = document.querySelectorAll('[data-testimonials-slider]');
    
    if (!testimonialsSliders.length) return;
    
    testimonialsSliders.forEach(slider => {
        const swiper = new Swiper(slider.querySelector('.swiper'), {
            modules: [Navigation, Pagination, Autoplay, EffectFade],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            speed: 1200,
            
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                clickable: true,
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
            },
            
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            },
        });
    });
}